import { z } from 'zod';

export const PageIdentifier = z.string();

export type PageIdentifier = z.infer<typeof PageIdentifier>;
